export var URL_BASE = process.env.REACT_APP_API_BASE_URL;
export var ITEMS_PER_PAGE = 10;
